import { api } from '../../core/network/api';

// SOFT = cash (The Market) · PREMIUM = gold bars (The Black Market).
export type MarketCurrency = 'SOFT' | 'PREMIUM';

// ── NPC store (catalog + quick-sell) ──
export interface CatalogItem {
  id: string; name: string;
  type: string; rarity: string;
  attack: number; defense: number; magic: number; speed: number; hp: number;
  setName: string | null; statusEffect: string | null;
  /** Intrinsic value — salvage anchor, NOT the asking price. */
  basePrice: number;
  /** Cash the Rack charges. Every item has one. */
  shopPrice: number;
  /** Gold bars — always the better value. `null` at COMMON, which has no premium SKU. */
  priceBars: number | null;
}

export const fetchCatalog = () => api.get<CatalogItem[]>('/market/catalog');

export const buyFromCatalog = (catalogId: string, currency: MarketCurrency = 'SOFT') =>
  api.post<{ bought: string; name: string; cost: number; currency: string }>(
    '/market/catalog/buy', { catalogId, currency });

export const quickSellArtifact = (artifactId: string) =>
  api.post<{ sold: string; value: number; cash: number }>('/market/quicksell', { artifactId });

// ── Two-tier sell: instant quicksell (50%) vs the fence (90%, 12h lock) ──
export interface SellQuote {
  gross: number;
  quick: { pct: number; payout: number };
  market: { pct: number; payout: number; lockHours: number };
}
export const fetchSellQuote = (artifactId: string) =>
  api.get<SellQuote>(`/market/sell-quote/${artifactId}`);

export const marketSellArtifact = (artifactId: string) =>
  api.post<{ pendingId: string; payout: number; matureAt: string; itemName: string }>(
    '/market/market-sell', { artifactId });

export interface PendingSaleEntry {
  id: string; itemName: string; rarity: string; type: string;
  payout: number; matureAt: string;
}
export interface PendingView {
  collected: number;
  cash: number | null;
  pending: PendingSaleEntry[];
}
/** Fetches locked payouts — server first credits any that have matured (lazy). */
export const fetchPending = () => api.get<PendingView>('/market/pending');
